import { useUser } from 'apps/vtex/hooks/useUser.ts'
import Icon from 'site/components/ui/Icon.tsx'

function Login({ isWhite }: { isWhite?: boolean }) {
    const { user } = useUser()
    const isLoggedIn = !!user.value?.email
    // const isLoggedIn = 'teste@teste.com';
    //console.log(user);
    return (
        <div
            data-logged={isLoggedIn}
            data-is-white={isWhite}
            class='dropdown dropdown-center dropdown-hover group hover:text-primary-700'
        >
            <div class='lg:p-2'>
                <a
                    class='flex items-center gap-2 '
                    href={isLoggedIn ? '/_secure/account#/profile' : '/login'}
                    aria-label='botão de login'
                >
                    <Icon
                        id='User'
                        class={`${isWhite ? 'text-white' : 'text-neutral-0'}`}
                        width={19}
                        height={19}
                        strokeWidth={0}
                        fill='none'
                    />
                    {!isLoggedIn && (
                        <span class='text-white text-sm font-bold font-lato md:hidden'>
                            Login/Cadastre-se
                        </span>
                    )}
                    {isLoggedIn && (
                        <span class="lg:hidden text-sm font-bold font-lato text-neutral-1 group-hover:text-primary-700 group-data-[is-white='true']:text-white">
                            {user?.value?.email}
                        </span>
                    )}
                    {!isLoggedIn && (
                        <ul class='text-center dropdown-content hidden group-hover:block bg-white top-6 right-1/2 translate-x-1/2 px-5 py-1 rounded-lg text-sm font-lato text-[#382F2D] shadow-lg'>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '-10px',
                                    right: '50%',
                                    transform: 'translateX(50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '10px solid transparent',
                                    borderRight: '10px solid transparent',
                                    borderBottom: '10px solid #fff',
                                }}
                            />
                            <li>
                                <span>Login/Cadastrar</span>
                            </li>
                        </ul>
                    )}
                </a>
            </div>
            <ul class='max-lg:hidden group-data-[logged=false]:hidden text-center dropdown-content py-1.5 bg-white w-52 top-11 right-1/2 translate-x-1/2 text-sm font-lato text-[#382F2D] shadow-lg before:h-4 before:w-full before:absolute before:left-0 before:bottom-full before:bg-transparent'>
                <div
                    style={{
                        position: 'absolute',
                        top: '-10px',
                        right: '50%',
                        transform: 'translateX(50%)',
                        width: '0',
                        height: '0',
                        borderLeft: '10px solid transparent',
                        borderRight: '10px solid transparent',
                        borderBottom: '10px solid #fff',
                    }}
                />
                <li>
                    <span class='block px-4 py-2'>
                        <strong>
                          Olá <span>{user?.value?.givenName}</span>!
                        </strong>{' '}
                        Bem-vindo
                    </span>
                </li>
                <li class='hover:underline'>
                    <a class='block px-4 py-2' href='/_secure/account#/orders'>
                        Meus pedidos
                    </a>
                </li>
                <li class='hover:underline'>
                    <a class='block px-4 py-2' href='/_secure/account#/profile'>
                        Minha conta
                    </a>
                </li>
                <li class='hover:underline'>
                    <a class='block px-4 py-2' href='/fale-conosco'>
                        Fale conosco
                    </a>
                </li>
                <li class='hover:underline text-danger-700'>
                    <button
                        onClick={() => {
                            window.location.href =
                                `${window.location.origin}/api/vtexid/pub/logout?scope=torratorra&returnUrl=${window.location?.href}`
                        }}
                        class='block px-4 py-2 text-danger-700 mx-auto'
                    >
                        Sair
                    </button>
                </li>
            </ul>
        </div>
    )
}

export default Login
